/* ============================================================
   Админка · Эфир — аккаунт трансляции, канал YouTube и
   расписание эфирного дня. Раньше всё это лежало в data.js и
   менялось только пересборкой фронта.
   ============================================================ */
import { useState } from 'react';
import { useFedContent } from '../content';
import { useAppStore } from '../../store';
import { Ic } from '../icons';
import { AdmCard, AdmIconBtn, AdmPrimaryBtn } from './ui';

const LANGS = [['ru', 'Русское'], ['kz', 'Казахское']];

export default function AdmLive() {
  const live = useFedContent((s) => s.live);
  const saveLive = useFedContent((s) => s.saveLive);
  const fire = useAppStore((s) => s.fire);

  const [draft, setDraft] = useState(() => ({
    tiktokUser: live.tiktokUser || '',
    youtube: live.youtube || '',
    schedule_ru: (live.schedule_ru || []).map((r) => ({ ...r })),
    schedule_kz: (live.schedule_kz || []).map((r) => ({ ...r })),
  }));
  const [lang, setLang] = useState('ru');
  const [busy, setBusy] = useState(false);

  const key = `schedule_${lang}`;
  const rows = draft[key] || [];
  const setRows = (next) => setDraft((d) => ({ ...d, [key]: next }));
  const updRow = (i, patch) => setRows(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= rows.length) return;
    const next = [...rows];
    [next[i], next[j]] = [next[j], next[i]];
    setRows(next);
  };

  const save = async () => {
    if (busy) return;
    setBusy(true);
    const ok = await saveLive({
      ...draft,
      tiktokUser: draft.tiktokUser.trim().replace(/^@/, ''),
      youtube: draft.youtube.trim(),
      schedule_ru: (draft.schedule_ru || []).filter((r) => r.t.trim() || r.x.trim()),
      schedule_kz: (draft.schedule_kz || []).filter((r) => r.t.trim() || r.x.trim()),
    });
    setBusy(false);
    if (ok) fire && fire('Страница «Эфир» обновлена', 'ok');
  };

  return (
    <div className="fed-admin-view flex flex-col gap-4">
      <AdmCard style={{ padding: 24, maxWidth: 720 }}>
        <div className="fed-grid-form">
          <label className="flex flex-col gap-[7px]">
            <span className="fed-label">Аккаунт TikTok (без @)</span>
            <input className="fed-input" value={draft.tiktokUser} placeholder="ya_znayu02" onChange={(e) => setDraft({ ...draft, tiktokUser: e.target.value })} />
          </label>
          <label className="flex flex-col gap-[7px]">
            <span className="fed-label">Канал YouTube</span>
            <input className="fed-input" value={draft.youtube} placeholder="https://youtube.com/@…" onChange={(e) => setDraft({ ...draft, youtube: e.target.value })} />
          </label>
        </div>
        <p className="text-fg-faint" style={{ fontSize: 11.5, marginTop: 10, lineHeight: 1.5 }}>
          Кнопки «Смотреть эфир» на странице ведут на tiktok.com/@{draft.tiktokUser || '…'}/live.
        </p>
      </AdmCard>

      <AdmCard style={{ padding: 24, maxWidth: 720 }}>
        <div className="flex items-center justify-between gap-3 flex-wrap" style={{ marginBottom: 16 }}>
          <div className="font-display font-semibold text-fg" style={{ fontSize: 16 }}>Расписание эфира</div>
          <div className="flex gap-2">
            {LANGS.map(([k, l]) => (
              <button
                key={k}
                onClick={() => setLang(k)}
                className="h-9 px-3.5 rounded-[9px] cursor-pointer font-display font-semibold uppercase border"
                style={{
                  fontSize: 12,
                  color: lang === k ? 'var(--fed-fg)' : 'var(--fed-fg-muted)',
                  borderColor: lang === k ? 'var(--fed-line-accent)' : 'var(--fed-line)',
                  background: lang === k ? 'rgba(225,18,23,.08)' : 'transparent',
                }}
              >
                {l}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-2.5">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center gap-2">
              <input
                className="fed-input text-center"
                style={{ width: 92, flexShrink: 0 }}
                placeholder="18:00"
                value={r.t || ''}
                onChange={(e) => updRow(i, { t: e.target.value })}
              />
              <input
                className="fed-input flex-1"
                placeholder="Что происходит в это время"
                value={r.x || ''}
                onChange={(e) => updRow(i, { x: e.target.value })}
              />
              <button className="fed-iconbtn" title="Выше" onClick={() => move(i, -1)} disabled={i === 0} style={i === 0 ? { opacity: 0.3, cursor: 'default' } : undefined}>
                <Ic name="chevD" size={16} style={{ transform: 'rotate(180deg)' }} />
              </button>
              <button className="fed-iconbtn" title="Ниже" onClick={() => move(i, 1)} disabled={i === rows.length - 1} style={i === rows.length - 1 ? { opacity: 0.3, cursor: 'default' } : undefined}>
                <Ic name="chevD" size={16} />
              </button>
              <AdmIconBtn name="trash" tint="danger" title="Удалить строку" onClick={() => setRows(rows.filter((_, j) => j !== i))} />
            </div>
          ))}
          {!rows.length && <div className="text-fg-faint" style={{ fontSize: 13 }}>Строк нет — на странице появится «Расписание пока не объявлено».</div>}
        </div>

        <button
          onClick={() => setRows([...rows, { t: '', x: '' }])}
          className="self-start h-10 px-4 rounded-[10px] cursor-pointer font-display font-semibold uppercase text-accent-bright"
          style={{ fontSize: 13, background: 'rgba(225,18,23,.08)', border: '1px solid var(--fed-line-accent)', marginTop: 14 }}
        >
          + Строка
        </button>
      </AdmCard>

      <div className="flex gap-2.5" style={{ maxWidth: 720 }}>
        <AdmPrimaryBtn icon="check" onClick={save}>{busy ? 'Сохраняем…' : 'Сохранить'}</AdmPrimaryBtn>
        <a href="/#live" target="_blank" rel="noopener noreferrer" className="fed-btn-ghost h-10 px-4 rounded-[10px] gap-2 no-underline inline-flex items-center" style={{ fontSize: 13 }}>
          <Ic name="external" size={15} /> Смотреть страницу
        </a>
      </div>
    </div>
  );
}
